import TabsComp from '../Tabs';
import './App.css';

function App() {
  return (
    <div className="App">
      <TabsComp />
    </div>
  );
}

export default App;
